// import React, { useState, useEffect, useRef } from 'react';
// import { getDatabasesWithCount } from '../api/databasesApi';
// import { useLoading } from './useLoading';
// import axios from 'axios';

// const API_BASE = process.env.REACT_APP_API_BASE_URL;

// export default function Catalog() {
//   const [databases, setDatabases] = useState([]);
//   const [selectedDatabase, setSelectedDatabase] = useState(null);
//   const [contacts, setContacts] = useState([]);
//   const [filteredContacts, setFilteredContacts] = useState([]);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [selectedLocations, setSelectedLocations] = useState([]);
//   const [availableLocations, setAvailableLocations] = useState([]);
//   const [selectAll, setSelectAll] = useState(false);

//   // Состояния для глобального поиска и удаления по email
//   const [showEmailDeleteModal, setShowEmailDeleteModal] = useState(false);
//   const [emailToDelete, setEmailToDelete] = useState('');
//   const [emailSearchResult, setEmailSearchResult] = useState(null);
//   const [emailSearchLoading, setEmailSearchLoading] = useState(false);
//   const [emailNotFound, setEmailNotFound] = useState(false);
  
//   // Состояния для выбора и удаления баз
//   const [selectedDatabaseIds, setSelectedDatabaseIds] = useState([]);
//   const [selectAllDatabases, setSelectAllDatabases] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [databaseToDelete, setDatabaseToDelete] = useState(null);
  
//   // Состояния для добавления контактов
//   const [showAddContactModal, setShowAddContactModal] = useState(false);
//   const [newContact, setNewContact] = useState({
//     companyName: '',
//     name: '',
//     email: '',
//     location: ''
//   });
//   const [bulkImportText, setBulkImportText] = useState('');
//   const [showBulkImportModal, setShowBulkImportModal] = useState(false);
//   const fileInputRef = useRef(null);
  
//   const { loading, withLoading } = useLoading();

//   const [showDeleteContactsConfirm, setShowDeleteContactsConfirm] = useState(false);
//   const [contactToDelete, setContactToDelete] = useState(null);   

//   const [showCreateDatabaseModal, setShowCreateDatabaseModal] = useState(false);
//   const [newDatabaseName, setNewDatabaseName] = useState('');

//   // НОВАЯ ФУНКЦИЯ: Поиск контакта по email
//   const searchContactByEmail = async () => {
//     if (!emailToDelete || !emailToDelete.includes('@')) {
//       alert('Введите корректный email');
//       return;
//     }

//     setEmailSearchLoading(true);
//     setEmailNotFound(false);
//     setEmailSearchResult(null);

//     try {
//       const response = await axios.get(
//         `${API_BASE}/contacts/search?email=${encodeURIComponent(emailToDelete)}`,
//         // { headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } }
//       );
      
//       setEmailSearchResult(response.data);
//     } catch (err) {
//       if (err.response?.status === 404) {
//         setEmailNotFound(true);
//         setEmailSearchResult(null);
//       } else {
//         console.error('Ошибка поиска:', err);
//         alert('Ошибка при поиске контакта');
//       }
//     } finally {
//       setEmailSearchLoading(false);
//     }
//   };

//   // НОВАЯ ФУНКЦИЯ: Удаление контакта по email
//   const handleDeleteContactByEmail = async () => {
//     if (!emailToDelete || !emailToDelete.includes('@')) {
//       alert('Введите корректный email');
//       return;
//     }

//     if (!window.confirm(`Вы уверены, что хотите удалить контакт с email: ${emailToDelete}?\nЭто действие нельзя отменить!`)) {
//       return;
//     }

//     try {
//       await axios.delete(
//         `${API_BASE}/contacts/by-email`,
//         {
//           // headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
//           data: { email: emailToDelete }
//         }
//       );
      
//       alert(`Контакт с email "${emailToDelete}" успешно удален!`);
      
//       // Обновляем текущий список контактов, если открыта база
//       if (selectedDatabase) {
//         const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
//         setContacts(res.data.map(contact => ({ ...contact, selected: false })));
//         setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
//       }
      
//       // Обновляем счетчики баз
//       await loadDatabases();
      
//       // Закрываем модалку и сбрасываем состояние
//       setShowEmailDeleteModal(false);
//       setEmailToDelete('');
//       setEmailSearchResult(null);
//       setEmailNotFound(false);
      
//     } catch (err) {
//       console.error('Ошибка удаления:', err);
//       alert('Ошибка при удалении контакта');
//     }
//   };

//   // Загружаем список баз
//   useEffect(() => {
//     loadDatabases();
//   }, []);

//   const loadDatabases = async () => {
//     try {
//       const res = await withLoading(() => getDatabasesWithCount());
//       setDatabases(res.data);
//       setSelectedDatabaseIds([]);
//       setSelectAllDatabases(false);
//     } catch (err) {
//       console.error('Ошибка загрузки баз:', err);
//     }
//   };

//   // Функция создания новой базы
//   const handleCreateDatabase = async () => {
//     if (!newDatabaseName.trim()) return alert("Введите название базы");

//     try {
//       await withLoading(() =>
//           axios.post(
//           `${API_BASE}/databases/`,
//           { name: newDatabaseName },
//           {
//               headers: {
//               // Authorization: `Bearer ${localStorage.getItem("token")}`
//               }
//           }
//           )
//       );

//       setNewDatabaseName('');
//       setShowCreateDatabaseModal(false);
      
//       // Перезагружаем список баз
//       await loadDatabases();
      
//       alert('База успешно создана');
      
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка при создании базы");
//     }
//   };

//   // Загружаем контакты выбранной базы
//   const loadDatabaseContacts = async (dbId) => {
//     try {
//       const res = await withLoading(() => 
//         axios.get(`${API_BASE}/databases/${dbId}/contacts`)
//       );
      
//       const contactsWithSelection = res.data.map(contact => ({
//         ...contact,
//         selected: false
//       }));
      
//       setContacts(contactsWithSelection);
//       setFilteredContacts(contactsWithSelection);
      
//       const locations = [...new Set(
//         res.data
//           .map(c => c.location)
//           .filter(loc => loc && loc.trim() !== '')
//       )];
      
//       setAvailableLocations(locations.sort());
      
//       setSelectedLocations([]);
//       setSearchTerm('');
//       setSelectAll(false);
      
//     } catch (err) {
//       console.error('Ошибка загрузки контактов:', err);
//       alert('Не удалось загрузить контакты. Проверьте консоль для деталей.');
//     }
//   };

//   // Функция удаления контактов
//   const handleDeleteContacts = async () => {
//     const contactsToDelete = contactToDelete ? [contactToDelete] : getSelectedContacts().map(c => c.id);
    
//     if (contactsToDelete.length === 0) return;

//     try {
//       await withLoading(() =>
//         axios.post(`${API_BASE}/databases/${selectedDatabase.id}/contacts/delete`, {
//           ids: contactsToDelete
//         })
//       );
      
//       // Перезагружаем контакты
//       const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
//       setContacts(res.data.map(contact => ({ ...contact, selected: false })));
//       setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
      
//       setShowDeleteContactsConfirm(false);
//       setContactToDelete(null);
      
//       alert(`Контакты успешно удалены (${contactsToDelete.length})`);
      
//     } catch (err) {
//       console.error('Ошибка удаления контактов:', err);
//       alert('Ошибка при удалении контактов');
//     }
//   };

//   // Функция подтверждения удаления контакта
//   const confirmDeleteContact = (contactId = null) => {
//     if (contactId) {
//       setContactToDelete(contactId);
//     }
//     setShowDeleteContactsConfirm(true);
//   };

//   // Фильтрация контактов
//   useEffect(() => {
//     let filtered = [...contacts];
    
//     if (searchTerm) {
//       filtered = filtered.filter(c => 
//         c.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
//         c.email?.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
    
//     if (selectedLocations.length > 0) {
//       filtered = filtered.filter(c => selectedLocations.includes(c.location));
//     }
    
//     setFilteredContacts(filtered);
//   }, [searchTerm, selectedLocations, contacts]);

//   // Обработчики для выбора контактов
//   const toggleContact = (id) => {
//     setFilteredContacts(prev => 
//       prev.map(c => c.id === id ? { ...c, selected: !c.selected } : c)
//     );
    
//     setContacts(prev =>
//       prev.map(c => c.id === id ? { ...c, selected: !c.selected } : c)
//     );
//   };

//   const toggleSelectAll = () => {
//     const newSelectAll = !selectAll;
//     setSelectAll(newSelectAll);
    
//     setFilteredContacts(prev =>
//       prev.map(c => ({ ...c, selected: newSelectAll }))
//     );
    
//     setContacts(prev =>
//       prev.map(c => {
//         const inFiltered = filteredContacts.some(fc => fc.id === c.id);
//         return inFiltered ? { ...c, selected: newSelectAll } : c;
//       })
//     );
//   };

//   // Функции для выбора баз
//   const toggleDatabaseSelect = (dbId, e) => {
//     e.stopPropagation();
    
//     setSelectedDatabaseIds(prev => {
//       if (prev.includes(dbId)) {
//         return prev.filter(id => id !== dbId);
//       } else {
//         return [...prev, dbId];
//       }
//     });
//   };

//   const toggleSelectAllDatabases = () => {
//     const newSelectAll = !selectAllDatabases;
//     setSelectAllDatabases(newSelectAll);
    
//     if (newSelectAll) {
//       setSelectedDatabaseIds(databases.map(db => db.id));
//     } else {
//       setSelectedDatabaseIds([]);
//     }
//   };

//   // Функция удаления баз
//   const handleDeleteDatabases = async () => {
//     const idsToDelete = databaseToDelete ? [databaseToDelete] : selectedDatabaseIds;
    
//     if (idsToDelete.length === 0) return;
    
//     try {
//       await withLoading(() =>
//         axios.post(`${API_BASE}/databases/delete`, { ids: idsToDelete })
//       );
      
//       await loadDatabases();
      
//       if (selectedDatabase && idsToDelete.includes(selectedDatabase.id)) {
//         setSelectedDatabase(null);
//         setContacts([]);
//         setFilteredContacts([]);
//       }
      
//       setShowDeleteConfirm(false);
//       setDatabaseToDelete(null);
      
//       alert(`Базы успешно удалены (${idsToDelete.length})`);
      
//     } catch (err) {
//       console.error('Ошибка удаления:', err);
//       alert('Ошибка при удалении баз');
//     }
//   };

//   const confirmDelete = (dbId = null) => {
//     if (dbId) {
//       setDatabaseToDelete(dbId);
//     }
//     setShowDeleteConfirm(true);
//   };

//   const getSelectedContacts = () => {
//     return contacts.filter(c => c.selected);
//   };

//   // Функция: Создание базы из выбранных контактов
//   const createNewDatabase = async () => {
//     const selected = getSelectedContacts();
//     if (selected.length === 0) {
//       alert('Выберите хотя бы один контакт');
//       return;
//     }

//     const dbName = prompt('Введите название для новой базы:');
//     if (!dbName) return;

//     try {
//       await withLoading(() =>
//         axios.post(`${API_BASE}/databases/from-selection`, {
//           name: dbName,
//           contacts: selected.map(({ id, companyName, name, email, location }) => ({
//             id, companyName, name, email, location
//           }))
//         })
//       );
      
//       alert('База успешно создана!');
//       loadDatabases();
//     } catch (err) {
//       console.error('Ошибка создания базы:', err);
//       alert('Ошибка при создании базы');
//     }
//   };

//   // Ручное добавление контакта
//   const handleAddContact = async () => {
//     if (!selectedDatabase) return alert("Сначала выберите базу");
//     if (!newContact.email || !newContact.email.includes('@')) return alert("Введите корректный email");

//     try {
//       await axios.post(`${API_BASE}/databases/${selectedDatabase.id}/import`, {
//         contacts: [newContact]
//       });

//       setNewContact({
//         companyName: '',
//         name: '',
//         email: '',
//         location: ''
//       });
      
//       setShowAddContactModal(false);
      
//       // Перезагружаем контакты
//       const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
//       setContacts(res.data.map(contact => ({ ...contact, selected: false })));
//       setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
      
//       alert('Контакт успешно добавлен');
      
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка при добавлении контакта");
//     }
//   };

//   // Обработка файла для массового импорта
//   const handleFileInput = (e) => {
//     const file = e.target.files[0];
//     if (!file) return;

//     const reader = new FileReader();

//     reader.onload = (event) => {
//       setBulkImportText(event.target.result || "");
//     };

//     reader.onerror = (err) => {
//       console.error(err);
//       alert("Ошибка при чтении файла");
//     };

//     reader.readAsText(file);
//     e.target.value = ""; // сброс
//   };

//   // Массовый импорт контактов
//   const handleBulkImport = async () => {
//     if (!selectedDatabase) return alert("Сначала выберите базу");

//     let parsed;
//     try {
//       parsed = JSON.parse(bulkImportText);
//       if (!Array.isArray(parsed)) throw new Error();
//     } catch {
//       return alert("Неверный формат JSON. Ожидается массив объектов");
//     }

//     try {
//       const res = await axios.post(`${API_BASE}/databases/${selectedDatabase.id}/import`, {
//         contacts: parsed
//       });

//       setBulkImportText('');
//       setShowBulkImportModal(false);
      
//       // Перезагружаем контакты
//       const contactsRes = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
//       setContacts(contactsRes.data.map(contact => ({ ...contact, selected: false })));
//       setFilteredContacts(contactsRes.data.map(contact => ({ ...contact, selected: false })));
      
//       if (res.data.skipped && res.data.skipped.length > 0) {
//         alert(`Импорт завершен. Пропущены дубли: ${res.data.skipped.join(', ')}`);
//       } else {
//         alert('Импорт завершен!');
//       }
      
//     } catch (err) {
//       console.error(err);
//       alert("Ошибка при импорте контактов");
//     }
//   };

//   return (
//     <div className="min-h-screen bg-gray-50 p-4">
//       {/* Лоадер */}
//       {loading && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
//         </div>
//       )}

//       {/* ===== ВСЕ МОДАЛКИ НА ОДНОМ УРОВНЕ (не вложенные) ===== */}

//       {/* Модалка удаления контакта по email */}
//       {showEmailDeleteModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-lg w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Удалить контакт по email</h3>
            
//             <div className="space-y-4">
//               <div className="flex gap-2">
//                 <input
//                   type="email"
//                   placeholder="Введите email контакта..."
//                   value={emailToDelete}
//                   onChange={(e) => {
//                     setEmailToDelete(e.target.value);
//                     setEmailSearchResult(null);
//                     setEmailNotFound(false);
//                   }}
//                   className="flex-1 border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//                   onKeyDown={(e) => {
//                     if (e.key === 'Enter') {
//                       searchContactByEmail();
//                     }
//                   }}
//                 />
//                 <button
//                   onClick={searchContactByEmail}
//                   disabled={emailSearchLoading}
//                   className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition disabled:opacity-50"
//                 >
//                   {emailSearchLoading ? 'Поиск...' : 'Найти'}
//                 </button>
//               </div>

//               {/* Результат поиска */}
//               {emailSearchResult && (
//                 <div className="border rounded-xl p-4 bg-green-50 border-green-200">
//                   <p className="font-semibold text-green-800">✅ Контакт найден!</p>
//                   <div className="mt-2 space-y-1 text-sm">
//                     <p><span className="font-medium">Имя:</span> {emailSearchResult.name || '-'}</p>
//                     <p><span className="font-medium">Компания:</span> {emailSearchResult.company_name || '-'}</p>
//                     <p><span className="font-medium">Email:</span> {emailSearchResult.email}</p>
//                     <p><span className="font-medium">Локация:</span> {emailSearchResult.location || '-'}</p>
//                     <p><span className="font-medium">База:</span> {emailSearchResult.database_name} (ID: {emailSearchResult.database_id})</p>
//                   </div>
//                 </div>
//               )}

//               {emailNotFound && (
//                 <div className="border rounded-xl p-4 bg-red-50 border-red-200">
//                   <p className="text-red-800">❌ Контакт с таким email не найден в ваших базах</p>
//                 </div>
//               )}
//             </div>

//             <div className="flex justify-end space-x-3 mt-6">
//               <button
//                 onClick={() => {
//                   setShowEmailDeleteModal(false);
//                   setEmailToDelete('');
//                   setEmailSearchResult(null);
//                   setEmailNotFound(false);
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleDeleteContactByEmail}
//                 disabled={!emailSearchResult}
//                 className={`px-4 py-2 rounded-xl text-white transition ${
//                   emailSearchResult 
//                     ? 'bg-red-600 hover:bg-red-700' 
//                     : 'bg-gray-300 cursor-not-allowed'
//                 }`}
//               >
//                 Удалить контакт
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Модалка подтверждения удаления баз */}
//       {showDeleteConfirm && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Подтверждение удаления</h3>
//             <p className="text-gray-600 mb-6">
//               {databaseToDelete 
//                 ? 'Вы точно хотите удалить эту базу?' 
//                 : `Вы точно хотите удалить выбранные базы (${selectedDatabaseIds.length})?`}
//               <br />
//               <span className="text-sm text-red-500">Это действие нельзя отменить!</span>
//             </p>
//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => {
//                   setShowDeleteConfirm(false);
//                   setDatabaseToDelete(null);
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleDeleteDatabases}
//                 className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition"
//               >
//                 Удалить
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Модалка ручного добавления контакта */}
//       {showAddContactModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Добавить контакт вручную</h3>
            
//             <div className="space-y-4">
//               <input
//                 type="text"
//                 placeholder="Название компании"
//                 value={newContact.companyName}
//                 onChange={(e) => setNewContact({...newContact, companyName: e.target.value})}
//                 className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//               />
              
//               <input
//                 type="text"
//                 placeholder="Контактное лицо"
//                 value={newContact.name}
//                 onChange={(e) => setNewContact({...newContact, name: e.target.value})}
//                 className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//               />
              
//               <input
//                 type="email"
//                 placeholder="Email *"
//                 value={newContact.email}
//                 onChange={(e) => setNewContact({...newContact, email: e.target.value})}
//                 className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//                 required
//               />
              
//               <input
//                 type="text"
//                 placeholder="Гео (город)"
//                 value={newContact.location}
//                 onChange={(e) => setNewContact({...newContact, location: e.target.value})}
//                 className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//               />
//             </div>

//             <div className="flex justify-end space-x-3 mt-6">
//               <button
//                 onClick={() => {
//                   setShowAddContactModal(false);
//                   setNewContact({
//                     companyName: '',
//                     name: '',
//                     email: '',
//                     location: ''
//                   });
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleAddContact}
//                 className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition"
//               >
//                 Добавить
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Модалка массового импорта */}
//       {showBulkImportModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-2xl w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Массовый импорт контактов</h3>
            
//             <div className="flex gap-2 mb-3">
//               <button
//                 onClick={() => fileInputRef.current.click()}
//                 className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition shadow-sm"
//               >
//                 Выбрать JSON файл
//               </button>
//               <input
//                 type="file"
//                 ref={fileInputRef}
//                 hidden
//                 accept=".json"
//                 onChange={handleFileInput}
//               />
//             </div>

//             <textarea
//               rows={10}
//               value={bulkImportText}
//               onChange={(e) => setBulkImportText(e.target.value)}
//               placeholder='[{"companyName": "Пример", "name": "Иван", "email": "ivan@mail.ru", "location": "Москва"}, ...]'
//               className="w-full p-3 border border-gray-200 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3 font-mono text-sm"
//             />

//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => {
//                   setShowBulkImportModal(false);
//                   setBulkImportText('');
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleBulkImport}
//                 disabled={!bulkImportText.trim()}
//                 className={`px-4 py-2 rounded-xl text-white transition ${
//                   bulkImportText.trim() 
//                     ? 'bg-blue-600 hover:bg-blue-700' 
//                     : 'bg-gray-300 cursor-not-allowed'
//                 }`}
//               >
//                 Импортировать
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Модалка подтверждения удаления контактов */}
//       {showDeleteContactsConfirm && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Подтверждение удаления</h3>
//             <p className="text-gray-600 mb-6">
//               {contactToDelete 
//                 ? 'Вы точно хотите удалить этот контакт?' 
//                 : `Вы точно хотите удалить выбранные контакты (${getSelectedContacts().length})?`}
//               <br />
//               <span className="text-sm text-red-500">Это действие нельзя отменить!</span>
//             </p>
//             <div className="flex justify-end space-x-3">
//               <button
//                 onClick={() => {
//                   setShowDeleteContactsConfirm(false);
//                   setContactToDelete(null);
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleDeleteContacts}
//                 className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition"
//               >
//                 Удалить
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Модалка создания новой базы */}
//       {showCreateDatabaseModal && (
//         <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
//           <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-xl">
//             <h3 className="text-xl font-semibold mb-4">Создать новую базу</h3>
            
//             <div className="space-y-4">
//               <input
//                 type="text"
//                 placeholder="Название базы *"
//                 value={newDatabaseName}
//                 onChange={(e) => setNewDatabaseName(e.target.value)}
//                 className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//                 autoFocus
//               />
//             </div>

//             <div className="flex justify-end space-x-3 mt-6">
//               <button
//                 onClick={() => {
//                   setShowCreateDatabaseModal(false);
//                   setNewDatabaseName('');
//                 }}
//                 className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition"
//               >
//                 Отмена
//               </button>
//               <button
//                 onClick={handleCreateDatabase}
//                 disabled={!newDatabaseName.trim()}
//                 className={`px-4 py-2 rounded-xl text-white transition ${
//                   newDatabaseName.trim() 
//                     ? 'bg-blue-600 hover:bg-blue-700' 
//                     : 'bg-gray-300 cursor-not-allowed'
//                 }`}
//               >
//                 Создать
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* ===== ОСНОВНОЙ КОНТЕНТ ===== */}

//       {/* Заголовок с кнопкой удаления по email */}
//       <div className="flex justify-between items-center mb-4">
//         <h1 className="text-2xl font-bold">Каталог баз контактов</h1>
//         <button
//           onClick={() => setShowEmailDeleteModal(true)}
//           className="px-4 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition flex items-center gap-2 shadow-sm"
//         >
//           <span>🔍</span>
//           Удалить контакт по email
//         </button>
//       </div>

//       <div className="flex space-x-4">
//         {/* Левая панель - список баз */}
//         <div className="w-1/4 bg-white rounded-2xl shadow-md p-4 h-fit">
//           <div className="flex justify-between items-center mb-3">
//             <h2 className="text-lg font-semibold">Доступные базы</h2>
            
//             <div className="flex space-x-2">
//               {/* Кнопка создания новой базы */}
//               <button
//                 onClick={() => setShowCreateDatabaseModal(true)}
//                 className="px-3 py-1 bg-green-600 text-white text-sm rounded-xl hover:bg-green-700 transition flex items-center gap-1"
//               >
//                 <span>➕</span>
//                 Новая база
//               </button>
              
//               {selectedDatabaseIds.length > 0 && (
//                 <button
//                   onClick={() => confirmDelete()}
//                   className="px-3 py-1 bg-red-500 text-white text-sm rounded-xl hover:bg-red-600 transition flex items-center gap-1"
//                 >
//                   <span>🗑️</span>
//                   Удалить ({selectedDatabaseIds.length})
//                 </button>
//               )}
//             </div>
//           </div>

//           <div className="flex items-center space-x-2 mb-2 pb-2 border-b">
//             <input
//               type="checkbox"
//               checked={selectAllDatabases}
//               onChange={toggleSelectAllDatabases}
//               className="w-4 h-4"
//             />
//             <span className="text-sm text-gray-600">Выбрать все</span>
//           </div>

//           <div className="space-y-2 max-h-[500px] overflow-y-auto">
//             {databases.map(db => (
//               <div
//                 key={db.id}
//                 className={`flex items-start space-x-2 p-2 rounded-xl transition ${
//                   selectedDatabase?.id === db.id
//                     ? 'bg-blue-50 border-2 border-blue-500'
//                     : 'border border-gray-200 hover:bg-gray-50'
//                 }`}
//               >
//                 <input
//                   type="checkbox"
//                   checked={selectedDatabaseIds.includes(db.id)}
//                   onChange={(e) => toggleDatabaseSelect(db.id, e)}
//                   className="mt-1 w-4 h-4 flex-shrink-0"
//                   onClick={(e) => e.stopPropagation()}
//                 />
                
//                 <div 
//                   className="flex-1 cursor-pointer"
//                   onClick={() => {
//                     setSelectedDatabase(db);
//                     loadDatabaseContacts(db.id);
//                   }}
//                 >
//                   <div className="font-medium">{db.name}</div>
//                   <div className="text-sm text-gray-500">
//                     {db.contacts_count || 0} контактов
//                   </div>
//                 </div>

//                 <button
//                   onClick={(e) => {
//                     e.stopPropagation();
//                     confirmDelete(db.id);
//                   }}
//                   className="text-gray-400 hover:text-red-500 transition p-1"
//                   title="Удалить базу"
//                 >
//                   <span className="text-lg">×</span>
//                 </button>
//               </div>
//             ))}

//             {databases.length === 0 && (
//               <div className="text-center py-8 text-gray-500">
//                 Нет доступных баз
//               </div>
//             )}
//           </div>
//         </div>

//         {/* Правая панель - контакты и фильтры */}
//         <div className="w-3/4 space-y-4">
//           {selectedDatabase ? (
//             <>
//               {/* Инфо и фильтры */}
//               <div className="bg-white rounded-2xl shadow-md p-4">
//                 <div className="flex justify-between items-center mb-4">
//                   <div>
//                     <h2 className="text-xl font-semibold">{selectedDatabase.name}</h2>
//                     <p className="text-gray-500">
//                       Всего контактов: {contacts.length} | 
//                       Выбрано: {getSelectedContacts().length}
//                     </p>
//                   </div>
                  
//                   <div className="flex space-x-2">
//                     {/* Кнопка удаления выбранных контактов */}
//                     {getSelectedContacts().length > 0 && (
//                       <button
//                         onClick={() => confirmDeleteContact()}
//                         className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition flex items-center gap-1"
//                       >
//                         <span>🗑️</span>
//                         Удалить выбранные ({getSelectedContacts().length})
//                       </button>
//                     )}
//                     <button
//                       onClick={() => setShowAddContactModal(true)}
//                       className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition flex items-center gap-1"
//                     >
//                       <span>➕</span>
//                       Добавить вручную
//                     </button>
                    
//                     <button
//                       onClick={() => setShowBulkImportModal(true)}
//                       className="px-4 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition flex items-center gap-1"
//                     >
//                       <span>📦</span>
//                       Массовый импорт
//                     </button>
                    
//                     {getSelectedContacts().length > 0 && (
//                       <button
//                         onClick={createNewDatabase}
//                         className="px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition"
//                       >
//                         Создать базу из выбранных ({getSelectedContacts().length})
//                       </button>
//                     )}
//                   </div>
//                 </div>

//                 {/* Фильтры */}
//                 <div className="flex space-x-4">
//                   <input
//                     type="text"
//                     placeholder="Поиск по компании, имени или email..."
//                     value={searchTerm}
//                     onChange={(e) => setSearchTerm(e.target.value)}
//                     className="flex-1 border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//                   />

//                   {availableLocations.length > 0 && (
//                     <select
//                       multiple
//                       value={selectedLocations}
//                       onChange={(e) => {
//                         const values = Array.from(e.target.selectedOptions, opt => opt.value);
//                         setSelectedLocations(values);
//                       }}
//                       className="w-48 border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
//                     >
//                       {availableLocations.map(loc => (
//                         <option key={loc} value={loc}>{loc}</option>
//                       ))}
//                     </select>
//                   )}
//                 </div>
//               </div>

//               {/* Таблица контактов */}
//               <div className="bg-white rounded-2xl shadow-md p-4">
//                 <div className="overflow-x-auto">
//                   <table className="w-full text-sm">
//                     <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
//                       <tr>
//                         <th className="px-2 py-2 text-left">
//                           <input
//                             type="checkbox"
//                             checked={selectAll}
//                             onChange={toggleSelectAll}
//                           />
//                         </th>
//                         <th className="px-2 py-2 text-left">Компания</th>
//                         <th className="px-2 py-2 text-left">Контактное лицо</th>
//                         <th className="px-2 py-2 text-left">Email</th>
//                         <th className="px-2 py-2 text-left">Гео</th>
//                         <th className="px-2 py-2 text-left">Действия</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {filteredContacts.map(contact => (
//                         <tr 
//                           key={contact.id} 
//                           className="border-t hover:bg-gray-50 transition"
//                         >
//                           <td className="px-2 py-2">
//                             <input
//                               type="checkbox"
//                               checked={contact.selected || false}
//                               onChange={() => toggleContact(contact.id)}
//                             />
//                           </td>
//                           <td className="px-2 py-2 font-medium">
//                             {contact.companyName || contact.company_name || '-'}
//                           </td>
//                           <td className="px-2 py-2">{contact.name || '-'}</td>
//                           <td className="px-2 py-2 text-blue-600">
//                             <a href={`mailto:${contact.email}`}>{contact.email}</a>
//                           </td>
//                           <td className="px-2 py-2">
//                             <span className="px-2 py-1 bg-gray-100 rounded-full text-xs">
//                               {contact.location || 'не указан'}
//                             </span>
//                           </td>
//                           <td className="px-2 py-2">
//                             <button
//                               onClick={() => confirmDeleteContact(contact.id)}
//                               className="text-red-400 hover:text-red-600 transition p-1"
//                               title="Удалить контакт"
//                             >
//                               <span className="text-lg">×</span>
//                             </button>
//                           </td>
//                         </tr>
//                       ))}
                      
//                       {filteredContacts.length === 0 && (
//                         <tr>
//                           <td colSpan="6" className="text-center py-8 text-gray-500">
//                             {contacts.length === 0 
//                               ? 'В этой базе пока нет контактов. Добавьте их вручную или импортируйте.'
//                               : 'Контакты не найдены по заданным фильтрам'}
//                           </td>
//                         </tr>
//                       )}
//                     </tbody>
//                   </table>
//                 </div>
//               </div>
//             </>
//           ) : (
//             <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500">
//               Выберите базу из списка слева
//             </div>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

import React, { useState, useEffect, useRef } from 'react';
import { getDatabasesWithCount } from '../api/databasesApi';
import { useLoading } from './useLoading';
import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_BASE_URL;

export default function Catalog() {
  const [databases, setDatabases] = useState([]);
  const [selectedDatabase, setSelectedDatabase] = useState(null);
  const [contacts, setContacts] = useState([]);
  const [filteredContacts, setFilteredContacts] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedLocations, setSelectedLocations] = useState([]);
  const [availableLocations, setAvailableLocations] = useState([]);
  const [selectAll, setSelectAll] = useState(false);

  const [showEmailDeleteModal, setShowEmailDeleteModal] = useState(false);
  const [emailToDelete, setEmailToDelete] = useState('');
  const [emailSearchResult, setEmailSearchResult] = useState(null);
  const [emailSearchLoading, setEmailSearchLoading] = useState(false);
  const [emailNotFound, setEmailNotFound] = useState(false);

  const [selectedDatabaseIds, setSelectedDatabaseIds] = useState([]);
  const [selectAllDatabases, setSelectAllDatabases] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [databaseToDelete, setDatabaseToDelete] = useState(null);

  const [showAddContactModal, setShowAddContactModal] = useState(false);
  const [newContact, setNewContact] = useState({
    companyName: '',
    name: '',
    email: '',
    location: ''
  });
  const [bulkImportText, setBulkImportText] = useState('');
  const [showBulkImportModal, setShowBulkImportModal] = useState(false);
  const fileInputRef = useRef(null);

  const { loading, withLoading } = useLoading();

  const [showDeleteContactsConfirm, setShowDeleteContactsConfirm] = useState(false);
  const [contactToDelete, setContactToDelete] = useState(null);

  const [showCreateDatabaseModal, setShowCreateDatabaseModal] = useState(false);
  const [newDatabaseName, setNewDatabaseName] = useState('');

  const searchContactByEmail = async () => {
    if (!emailToDelete || !emailToDelete.includes('@')) {
      alert('Введите корректный email');
      return;
    }
    setEmailSearchLoading(true);
    setEmailNotFound(false);
    setEmailSearchResult(null);
    try {
      const response = await axios.get(
        `${API_BASE}/contacts/search?email=${encodeURIComponent(emailToDelete)}`
      );
      setEmailSearchResult(response.data);
    } catch (err) {
      if (err.response?.status === 404) {
        setEmailNotFound(true);
        setEmailSearchResult(null);
      } else {
        console.error('Ошибка поиска:', err);
        alert('Ошибка при поиске контакта');
      }
    } finally {
      setEmailSearchLoading(false);
    }
  };

  const handleDeleteContactByEmail = async () => {
    if (!emailToDelete || !emailToDelete.includes('@')) {
      alert('Введите корректный email');
      return;
    }
    if (!window.confirm(`Вы уверены, что хотите удалить контакт с email: ${emailToDelete}?\nЭто действие нельзя отменить!`)) {
      return;
    }
    try {
      await axios.delete(
        `${API_BASE}/contacts/by-email`,
        { data: { email: emailToDelete } }
      );
      alert(`Контакт с email "${emailToDelete}" успешно удален!`);
      if (selectedDatabase) {
        const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
        setContacts(res.data.map(contact => ({ ...contact, selected: false })));
        setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
      }
      await loadDatabases();
      setShowEmailDeleteModal(false);
      setEmailToDelete('');
      setEmailSearchResult(null);
      setEmailNotFound(false);
    } catch (err) {
      console.error('Ошибка удаления:', err);
      alert('Ошибка при удалении контакта');
    }
  };

  useEffect(() => { loadDatabases(); }, []);

  const loadDatabases = async () => {
    try {
      const res = await withLoading(() => getDatabasesWithCount());
      setDatabases(res.data);
      setSelectedDatabaseIds([]);
      setSelectAllDatabases(false);
    } catch (err) {
      console.error('Ошибка загрузки баз:', err);
    }
  };

  const handleCreateDatabase = async () => {
    if (!newDatabaseName.trim()) return alert("Введите название базы");
    try {
      await withLoading(() =>
        axios.post(`${API_BASE}/databases/`, { name: newDatabaseName })
      );
      setNewDatabaseName('');
      setShowCreateDatabaseModal(false);
      await loadDatabases();
      alert('База успешно создана');
    } catch (err) {
      console.error(err);
      alert("Ошибка при создании базы");
    }
  };

  const loadDatabaseContacts = async (dbId) => {
    try {
      const res = await withLoading(() =>
        axios.get(`${API_BASE}/databases/${dbId}/contacts`)
      );
      const contactsWithSelection = res.data.map(contact => ({
        ...contact,
        selected: false
      }));
      setContacts(contactsWithSelection);
      setFilteredContacts(contactsWithSelection);
      const locations = [...new Set(
        res.data.map(c => c.location).filter(loc => loc && loc.trim() !== '')
      )];
      setAvailableLocations(locations.sort());
      setSelectedLocations([]);
      setSearchTerm('');
      setSelectAll(false);
    } catch (err) {
      console.error('Ошибка загрузки контактов:', err);
      alert('Не удалось загрузить контакты.');
    }
  };

  const handleDeleteContacts = async () => {
    const contactsToDelete = contactToDelete ? [contactToDelete] : getSelectedContacts().map(c => c.id);
    if (contactsToDelete.length === 0) return;
    try {
      await withLoading(() =>
        axios.post(`${API_BASE}/databases/${selectedDatabase.id}/contacts/delete`, {
          ids: contactsToDelete
        })
      );
      const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
      setContacts(res.data.map(contact => ({ ...contact, selected: false })));
      setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
      setShowDeleteContactsConfirm(false);
      setContactToDelete(null);
      alert(`Контакты успешно удалены (${contactsToDelete.length})`);
    } catch (err) {
      console.error('Ошибка удаления контактов:', err);
      alert('Ошибка при удалении контактов');
    }
  };

  const confirmDeleteContact = (contactId = null) => {
    if (contactId) setContactToDelete(contactId);
    setShowDeleteContactsConfirm(true);
  };

  useEffect(() => {
    let filtered = [...contacts];
    if (searchTerm) {
      filtered = filtered.filter(c =>
        c.companyName?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        c.email?.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (selectedLocations.length > 0) {
      filtered = filtered.filter(c => selectedLocations.includes(c.location));
    }
    setFilteredContacts(filtered);
  }, [searchTerm, selectedLocations, contacts]);

  const toggleContact = (id) => {
    setFilteredContacts(prev => prev.map(c => c.id === id ? { ...c, selected: !c.selected } : c));
    setContacts(prev => prev.map(c => c.id === id ? { ...c, selected: !c.selected } : c));
  };

  const toggleSelectAll = () => {
    const newSelectAll = !selectAll;
    setSelectAll(newSelectAll);
    setFilteredContacts(prev => prev.map(c => ({ ...c, selected: newSelectAll })));
    setContacts(prev => prev.map(c => {
      const inFiltered = filteredContacts.some(fc => fc.id === c.id);
      return inFiltered ? { ...c, selected: newSelectAll } : c;
    }));
  };

  const toggleDatabaseSelect = (dbId, e) => {
    e.stopPropagation();
    setSelectedDatabaseIds(prev =>
      prev.includes(dbId) ? prev.filter(id => id !== dbId) : [...prev, dbId]
    );
  };

  const toggleSelectAllDatabases = () => {
    const newSelectAll = !selectAllDatabases;
    setSelectAllDatabases(newSelectAll);
    if (newSelectAll) setSelectedDatabaseIds(databases.map(db => db.id));
    else setSelectedDatabaseIds([]);
  };

  const handleDeleteDatabases = async () => {
    const idsToDelete = databaseToDelete ? [databaseToDelete] : selectedDatabaseIds;
    if (idsToDelete.length === 0) return;
    try {
      await withLoading(() =>
        axios.post(`${API_BASE}/databases/delete`, { ids: idsToDelete })
      );
      await loadDatabases();
      if (selectedDatabase && idsToDelete.includes(selectedDatabase.id)) {
        setSelectedDatabase(null);
        setContacts([]);
        setFilteredContacts([]);
      }
      setShowDeleteConfirm(false);
      setDatabaseToDelete(null);
      alert(`Базы успешно удалены (${idsToDelete.length})`);
    } catch (err) {
      console.error('Ошибка удаления:', err);
      alert('Ошибка при удалении баз');
    }
  };

  const confirmDelete = (dbId = null) => {
    if (dbId) setDatabaseToDelete(dbId);
    setShowDeleteConfirm(true);
  };

  const getSelectedContacts = () => contacts.filter(c => c.selected);

  const createNewDatabase = async () => {
    const selected = getSelectedContacts();
    if (selected.length === 0) {
      alert('Выберите хотя бы один контакт');
      return;
    }
    const dbName = prompt('Введите название для новой базы:');
    if (!dbName) return;
    try {
      await withLoading(() =>
        axios.post(`${API_BASE}/databases/from-selection`, {
          name: dbName,
          contacts: selected.map(({ id, companyName, name, email, location }) => ({
            id, companyName, name, email, location
          }))
        })
      );
      alert('База успешно создана!');
      loadDatabases();
    } catch (err) {
      console.error('Ошибка создания базы:', err);
      alert('Ошибка при создании базы');
    }
  };

  const handleAddContact = async () => {
    if (!selectedDatabase) return alert("Сначала выберите базу");
    if (!newContact.email || !newContact.email.includes('@')) return alert("Введите корректный email");
    try {
      await axios.post(`${API_BASE}/databases/${selectedDatabase.id}/import`, {
        contacts: [newContact]
      });
      setNewContact({ companyName: '', name: '', email: '', location: '' });
      setShowAddContactModal(false);
      const res = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
      setContacts(res.data.map(contact => ({ ...contact, selected: false })));
      setFilteredContacts(res.data.map(contact => ({ ...contact, selected: false })));
      alert('Контакт успешно добавлен');
    } catch (err) {
      console.error(err);
      alert("Ошибка при добавлении контакта");
    }
  };

  const handleFileInput = (e) => {
    const file = e.target.files[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (event) => setBulkImportText(event.target.result || "");
    reader.onerror = (err) => {
      console.error(err);
      alert("Ошибка при чтении файла");
    };
    reader.readAsText(file);
    e.target.value = "";
  };

  const handleBulkImport = async () => {
    if (!selectedDatabase) return alert("Сначала выберите базу");
    let parsed;
    try {
      parsed = JSON.parse(bulkImportText);
      if (!Array.isArray(parsed)) throw new Error();
    } catch {
      return alert("Неверный формат JSON. Ожидается массив объектов");
    }
    try {
      const res = await axios.post(`${API_BASE}/databases/${selectedDatabase.id}/import`, {
        contacts: parsed
      });
      setBulkImportText('');
      setShowBulkImportModal(false);
      const contactsRes = await axios.get(`${API_BASE}/databases/${selectedDatabase.id}/contacts`);
      setContacts(contactsRes.data.map(contact => ({ ...contact, selected: false })));
      setFilteredContacts(contactsRes.data.map(contact => ({ ...contact, selected: false })));
      if (res.data.skipped && res.data.skipped.length > 0) {
        alert(`Импорт завершен. Пропущены дубли: ${res.data.skipped.join(', ')}`);
      } else {
        alert('Импорт завершен!');
      }
    } catch (err) {
      console.error(err);
      alert("Ошибка при импорте контактов");
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-3 md:p-4">
      {loading && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50">
          <div className="w-20 h-20 border-8 border-gray-200 border-t-8 border-t-blue-600 rounded-full animate-spin" />
        </div>
      )}

      {/* ===== МОДАЛКИ ===== */}

      {/* Удаление контакта по email */}
      {showEmailDeleteModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-lg w-full shadow-xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Удалить контакт по email</h3>
            <div className="space-y-4">
              <div className="flex gap-2 flex-col md:flex-row">
                <input
                  type="email"
                  placeholder="Введите email..."
                  value={emailToDelete}
                  onChange={(e) => {
                    setEmailToDelete(e.target.value);
                    setEmailSearchResult(null);
                    setEmailNotFound(false);
                  }}
                  className="flex-1 border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  onKeyDown={(e) => e.key === 'Enter' && searchContactByEmail()}
                />
                <button
                  onClick={searchContactByEmail}
                  disabled={emailSearchLoading}
                  className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition disabled:opacity-50 text-sm"
                >
                  {emailSearchLoading ? 'Поиск...' : 'Найти'}
                </button>
              </div>

              {emailSearchResult && (
                <div className="border rounded-xl p-3 md:p-4 bg-green-50 border-green-200 text-sm">
                  <p className="font-semibold text-green-800 mb-2">✅ Контакт найден!</p>
                  <div className="space-y-1">
                    <p><span className="font-medium">Имя:</span> {emailSearchResult.name || '-'}</p>
                    <p><span className="font-medium">Компания:</span> {emailSearchResult.company_name || '-'}</p>
                    <p><span className="font-medium">Email:</span> {emailSearchResult.email}</p>
                    <p><span className="font-medium">Локация:</span> {emailSearchResult.location || '-'}</p>
                    <p><span className="font-medium">База:</span> {emailSearchResult.database_name}</p>
                  </div>
                </div>
              )}

              {emailNotFound && (
                <div className="border rounded-xl p-3 md:p-4 bg-red-50 border-red-200 text-sm">
                  <p className="text-red-800">❌ Контакт не найден</p>
                </div>
              )}
            </div>

            <div className="flex flex-col md:flex-row md:justify-end gap-2 mt-6">
              <button
                onClick={() => {
                  setShowEmailDeleteModal(false);
                  setEmailToDelete('');
                  setEmailSearchResult(null);
                  setEmailNotFound(false);
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleDeleteContactByEmail}
                disabled={!emailSearchResult}
                className={`px-4 py-2 rounded-xl text-white transition order-1 md:order-2 ${
                  emailSearchResult ? 'bg-red-600 hover:bg-red-700' : 'bg-gray-300 cursor-not-allowed'
                }`}
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Подтверждение удаления баз */}
      {showDeleteConfirm && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-md w-full shadow-xl">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Подтверждение</h3>
            <p className="text-gray-600 mb-6 text-sm">
              {databaseToDelete
                ? 'Удалить эту базу?'
                : `Удалить выбранные базы (${selectedDatabaseIds.length})?`}
              <br />
              <span className="text-red-500">Это действие нельзя отменить!</span>
            </p>
            <div className="flex flex-col md:flex-row md:justify-end gap-2">
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setDatabaseToDelete(null);
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleDeleteDatabases}
                className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition order-1 md:order-2"
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Добавление контакта */}
      {showAddContactModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-md w-full shadow-xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Добавить контакт</h3>
            <div className="space-y-3">
              <input
                type="text"
                placeholder="Название компании"
                value={newContact.companyName}
                onChange={(e) => setNewContact({ ...newContact, companyName: e.target.value })}
                className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
              />
              <input
                type="text"
                placeholder="Контактное лицо"
                value={newContact.name}
                onChange={(e) => setNewContact({ ...newContact, name: e.target.value })}
                className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
              />
              <input
                type="email"
                placeholder="Email *"
                value={newContact.email}
                onChange={(e) => setNewContact({ ...newContact, email: e.target.value })}
                className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                required
              />
              <input
                type="text"
                placeholder="Гео (город)"
                value={newContact.location}
                onChange={(e) => setNewContact({ ...newContact, location: e.target.value })}
                className="w-full border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
              />
            </div>
            <div className="flex flex-col md:flex-row md:justify-end gap-2 mt-6">
              <button
                onClick={() => {
                  setShowAddContactModal(false);
                  setNewContact({ companyName: '', name: '', email: '', location: '' });
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleAddContact}
                className="px-4 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition order-1 md:order-2"
              >
                Добавить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Массовый импорт */}
      {showBulkImportModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-2xl w-full shadow-xl max-h-[90vh] overflow-y-auto">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Массовый импорт</h3>
            <div className="flex gap-2 mb-3">
              <button
                onClick={() => fileInputRef.current.click()}
                className="px-3 md:px-4 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition shadow-sm text-sm w-full md:w-auto"
              >
                📁 Выбрать JSON файл
              </button>
              <input
                type="file"
                ref={fileInputRef}
                hidden
                accept=".json"
                onChange={handleFileInput}
              />
            </div>
            <textarea
              rows={10}
              value={bulkImportText}
              onChange={(e) => setBulkImportText(e.target.value)}
              placeholder='[{"companyName": "Пример", "name": "Иван", "email": "ivan@mail.ru", "location": "Москва"}]'
              className="w-full p-3 border border-gray-200 rounded-2xl resize-none focus:outline-none focus:ring-2 focus:ring-blue-400 mb-3 font-mono text-xs md:text-sm"
            />
            <div className="flex flex-col md:flex-row md:justify-end gap-2">
              <button
                onClick={() => {
                  setShowBulkImportModal(false);
                  setBulkImportText('');
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleBulkImport}
                disabled={!bulkImportText.trim()}
                className={`px-4 py-2 rounded-xl text-white transition order-1 md:order-2 ${
                  bulkImportText.trim() ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300 cursor-not-allowed'
                }`}
              >
                Импортировать
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Удаление контактов */}
      {showDeleteContactsConfirm && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-md w-full shadow-xl">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Подтверждение</h3>
            <p className="text-gray-600 mb-6 text-sm">
              {contactToDelete
                ? 'Удалить этот контакт?'
                : `Удалить выбранные контакты (${getSelectedContacts().length})?`}
              <br />
              <span className="text-red-500">Это действие нельзя отменить!</span>
            </p>
            <div className="flex flex-col md:flex-row md:justify-end gap-2">
              <button
                onClick={() => {
                  setShowDeleteContactsConfirm(false);
                  setContactToDelete(null);
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleDeleteContacts}
                className="px-4 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition order-1 md:order-2"
              >
                Удалить
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Создание базы */}
      {showCreateDatabaseModal && (
        <div className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-3">
          <div className="bg-white rounded-2xl p-4 md:p-6 max-w-md w-full shadow-xl">
            <h3 className="text-lg md:text-xl font-semibold mb-4">Создать базу</h3>
            <input
              type="text"
              placeholder="Название базы *"
              value={newDatabaseName}
              onChange={(e) => setNewDatabaseName(e.target.value)}
              className="w-full border rounded-xl px-3 py-2 focus:ring-2 focus:ring-blue-400"
              autoFocus
            />
            <div className="flex flex-col md:flex-row md:justify-end gap-2 mt-6">
              <button
                onClick={() => {
                  setShowCreateDatabaseModal(false);
                  setNewDatabaseName('');
                }}
                className="px-4 py-2 border border-gray-300 rounded-xl hover:bg-gray-50 transition order-2 md:order-1"
              >
                Отмена
              </button>
              <button
                onClick={handleCreateDatabase}
                disabled={!newDatabaseName.trim()}
                className={`px-4 py-2 rounded-xl text-white transition order-1 md:order-2 ${
                  newDatabaseName.trim() ? 'bg-blue-600 hover:bg-blue-700' : 'bg-gray-300 cursor-not-allowed'
                }`}
              >
                Создать
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ===== ОСНОВНОЙ КОНТЕНТ ===== */}

      {/* Заголовок */}
      <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
        <h1 className="text-xl md:text-2xl font-bold">Каталог баз</h1>
        <button
          onClick={() => setShowEmailDeleteModal(true)}
          className="px-3 md:px-4 py-2 bg-red-600 text-white rounded-xl hover:bg-red-700 transition flex items-center justify-center gap-2 shadow-sm text-sm w-full md:w-auto"
        >
          <span>🔍</span>
          Удалить по email
        </button>
      </div>

      <div className="flex flex-col md:flex-row md:space-x-4 space-y-4 md:space-y-0">

        {/* ===== ЛЕВАЯ ПАНЕЛЬ: БАЗЫ ===== */}
        <div className="w-full md:w-1/4 bg-white rounded-2xl shadow-md p-3 md:p-4 h-fit">
          <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-2 mb-3">
            <h2 className="text-base md:text-lg font-semibold">Базы</h2>
            <div className="flex gap-2 flex-wrap">
              <button
                onClick={() => setShowCreateDatabaseModal(true)}
                className="flex-1 md:flex-none px-3 py-1.5 bg-green-600 text-white text-xs md:text-sm rounded-xl hover:bg-green-700 transition"
              >
                ➕ Новая
              </button>
              {selectedDatabaseIds.length > 0 && (
                <button
                  onClick={() => confirmDelete()}
                  className="flex-1 md:flex-none px-3 py-1.5 bg-red-500 text-white text-xs md:text-sm rounded-xl hover:bg-red-600 transition"
                >
                  🗑️ ({selectedDatabaseIds.length})
                </button>
              )}
            </div>
          </div>

          <div className="flex items-center gap-2 mb-2 pb-2 border-b">
            <input
              type="checkbox"
              checked={selectAllDatabases}
              onChange={toggleSelectAllDatabases}
              className="w-4 h-4"
            />
            <span className="text-xs md:text-sm text-gray-600">Выбрать все</span>
          </div>

          <div className="space-y-2 max-h-96 md:max-h-[500px] overflow-y-auto">
            {databases.map(db => (
              <div
                key={db.id}
                className={`flex items-start gap-2 p-2 rounded-xl transition cursor-pointer ${
                  selectedDatabase?.id === db.id
                    ? 'bg-blue-50 border-2 border-blue-500'
                    : 'border border-gray-200 hover:bg-gray-50'
                }`}
              >
                <input
                  type="checkbox"
                  checked={selectedDatabaseIds.includes(db.id)}
                  onChange={(e) => toggleDatabaseSelect(db.id, e)}
                  className="mt-1 w-4 h-4 flex-shrink-0"
                  onClick={(e) => e.stopPropagation()}
                />

                <div
                  className="flex-1 min-w-0"
                  onClick={() => {
                    setSelectedDatabase(db);
                    loadDatabaseContacts(db.id);
                  }}
                >
                  <div className="font-medium text-sm truncate">{db.name}</div>
                  <div className="text-xs text-gray-500">
                    {db.contacts_count || 0} контактов
                  </div>
                </div>

                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    confirmDelete(db.id);
                  }}
                  className="text-gray-400 hover:text-red-500 transition p-1 flex-shrink-0"
                  title="Удалить базу"
                >
                  <span className="text-lg leading-none">×</span>
                </button>
              </div>
            ))}

            {databases.length === 0 && (
              <div className="text-center py-6 text-gray-500 text-sm">
                Нет доступных баз
              </div>
            )}
          </div>
        </div>

        {/* ===== ПРАВАЯ ПАНЕЛЬ ===== */}
        <div className="w-full md:w-3/4 space-y-4">
          {selectedDatabase ? (
            <>
              {/* Инфо и фильтры */}
              <div className="bg-white rounded-2xl shadow-md p-3 md:p-4">
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3 mb-4">
                  <div>
                    <h2 className="text-base md:text-xl font-semibold">{selectedDatabase.name}</h2>
                    <p className="text-xs md:text-sm text-gray-500">
                      Всего: {contacts.length} | Выбрано: {getSelectedContacts().length}
                    </p>
                  </div>

                  <div className="flex gap-2 flex-wrap">
                    {getSelectedContacts().length > 0 && (
                      <button
                        onClick={() => confirmDeleteContact()}
                        className="flex-1 md:flex-none px-3 py-2 bg-red-500 text-white rounded-xl hover:bg-red-600 transition text-xs md:text-sm"
                      >
                        🗑️ Удалить ({getSelectedContacts().length})
                      </button>
                    )}
                    <button
                      onClick={() => setShowAddContactModal(true)}
                      className="flex-1 md:flex-none px-3 py-2 bg-blue-600 text-white rounded-xl hover:bg-blue-700 transition text-xs md:text-sm"
                    >
                      ➕ Добавить
                    </button>
                    <button
                      onClick={() => setShowBulkImportModal(true)}
                      className="flex-1 md:flex-none px-3 py-2 bg-purple-600 text-white rounded-xl hover:bg-purple-700 transition text-xs md:text-sm"
                    >
                      📦 Импорт
                    </button>
                  </div>
                </div>

                {getSelectedContacts().length > 0 && (
                  <button
                    onClick={createNewDatabase}
                    className="w-full mb-3 px-3 py-2 bg-green-600 text-white rounded-xl hover:bg-green-700 transition text-sm"
                  >
                    Создать базу из выбранных ({getSelectedContacts().length})
                  </button>
                )}

                {/* Фильтры */}
                <div className="flex flex-col md:flex-row gap-2">
                  <input
                    type="text"
                    placeholder="Поиск по компании, имени, email..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    className="flex-1 border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400"
                  />

                  {availableLocations.length > 0 && (
                    <select
                      multiple
                      value={selectedLocations}
                      onChange={(e) => {
                        const values = Array.from(e.target.selectedOptions, opt => opt.value);
                        setSelectedLocations(values);
                      }}
                      className="w-full md:w-48 border rounded-xl px-3 py-2 text-sm focus:ring-2 focus:ring-blue-400 h-20 md:h-auto"
                    >
                      {availableLocations.map(loc => (
                        <option key={loc} value={loc}>{loc}</option>
                      ))}
                    </select>
                  )}
                </div>
              </div>

              {/* Desktop: TABLE */}
              <div className="hidden md:block bg-white rounded-2xl shadow-md p-4">
                <div className="overflow-x-auto">
                  <table className="w-full text-sm">
                    <thead className="bg-gray-100 text-gray-600 uppercase text-xs tracking-wider">
                      <tr>
                        <th className="px-2 py-2 text-left">
                          <input type="checkbox" checked={selectAll} onChange={toggleSelectAll} />
                        </th>
                        <th className="px-2 py-2 text-left">Компания</th>
                        <th className="px-2 py-2 text-left">Контакт</th>
                        <th className="px-2 py-2 text-left">Email</th>
                        <th className="px-2 py-2 text-left">Гео</th>
                        <th className="px-2 py-2 text-left">Действия</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredContacts.map(contact => (
                        <tr key={contact.id} className="border-t hover:bg-gray-50 transition">
                          <td className="px-2 py-2">
                            <input
                              type="checkbox"
                              checked={contact.selected || false}
                              onChange={() => toggleContact(contact.id)}
                            />
                          </td>
                          <td className="px-2 py-2 font-medium">
                            {contact.companyName || contact.company_name || '-'}
                          </td>
                          <td className="px-2 py-2">{contact.name || '-'}</td>
                          <td className="px-2 py-2 text-blue-600">
                            <a href={`mailto:${contact.email}`}>{contact.email}</a>
                          </td>
                          <td className="px-2 py-2">
                            <span className="px-2 py-1 bg-gray-100 rounded-full text-xs">
                              {contact.location || 'не указан'}
                            </span>
                          </td>
                          <td className="px-2 py-2">
                            <button
                              onClick={() => confirmDeleteContact(contact.id)}
                              className="text-red-400 hover:text-red-600 transition p-1"
                              title="Удалить"
                            >
                              <span className="text-lg">×</span>
                            </button>
                          </td>
                        </tr>
                      ))}
                      {filteredContacts.length === 0 && (
                        <tr>
                          <td colSpan="6" className="text-center py-8 text-gray-500">
                            {contacts.length === 0
                              ? 'В базе нет контактов'
                              : 'Контакты не найдены'}
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Mobile: CARDS */}
              <div className="md:hidden space-y-2">
                {/* Кнопка «Выбрать все» */}
                {filteredContacts.length > 0 && (
                  <div className="flex items-center gap-2 px-3 py-2 bg-white rounded-xl shadow-sm">
                    <input
                      type="checkbox"
                      checked={selectAll}
                      onChange={toggleSelectAll}
                      className="w-4 h-4"
                    />
                    <span className="text-xs text-gray-600">
                      Выбрать все ({filteredContacts.length})
                    </span>
                  </div>
                )}

                {filteredContacts.length === 0 && (
                  <div className="text-center py-8 text-gray-400 text-sm bg-white rounded-xl">
                    {contacts.length === 0
                      ? 'В базе нет контактов'
                      : 'Контакты не найдены'}
                  </div>
                )}

                {filteredContacts.map(contact => (
                  <div
                    key={contact.id}
                    className={`bg-white rounded-xl shadow-sm p-3 flex items-start gap-3 transition ${
                      contact.selected ? 'ring-2 ring-blue-400' : ''
                    }`}
                  >
                    <input
                      type="checkbox"
                      checked={contact.selected || false}
                      onChange={() => toggleContact(contact.id)}
                      className="mt-1 w-4 h-4 flex-shrink-0"
                    />

                    <div className="flex-1 min-w-0">
                      <div className="font-medium text-sm text-gray-800 truncate">
                        {contact.companyName || contact.company_name || '-'}
                      </div>
                      {contact.name && (
                        <div className="text-xs text-gray-500 truncate mt-0.5">
                          👤 {contact.name}
                        </div>
                      )}
                      <a
                        href={`mailto:${contact.email}`}
                        className="text-xs text-blue-600 truncate block mt-0.5"
                      >
                        📧 {contact.email}
                      </a>
                      {contact.location && (
                        <div className="text-[10px] text-gray-400 mt-0.5">
                          📍 {contact.location}
                        </div>
                      )}
                    </div>

                    <button
                      onClick={() => confirmDeleteContact(contact.id)}
                      className="text-red-400 hover:text-red-600 p-1 flex-shrink-0 text-lg leading-none"
                      title="Удалить"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </>
          ) : (
            <div className="bg-white rounded-2xl shadow-md p-8 text-center text-gray-500 text-sm">
              Выберите базу из списка
            </div>
          )}
        </div>
      </div>
    </div>
  );
}